var map = {
	"./Analytics/": "18bb",
	"./Dashboard/": "6ef3",
	"./Downgrade/": "162b",
	"./Instant/": "3058",
	"./Pricing/": "10b3",
	"./Shopify/": "3304",
	"./Static/": "28fe",
	"./Store/": "6c29",
	"./ThankYouPage/": "c369",
	"./Uninstall/": "d480"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c3c5";